import { createContext } from "react";

// Context to render elements conditionally while creating downloadable report
export const ReportPdfContext = createContext({ reportPdfView: false });
